module.exports = "build/assets/floatingGirl.94f46fe1.png";